import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ee9886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogue-option-wrapper" }
const _hoisted_2 = ["onClick"]

import { BrainViewModel } from '../../../../ecs/brains/Brain';
import { Branch } from '../../../../ecs/dialog/component';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionSelectComponent',
  props: {
    brain: null
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const props = __props as {
  brain: BrainViewModel;
}



const instantiateAvailableDialog = () => {
  const availableDialog: Branch[] = [];
  props.brain.options.forEach((edge) => {
    if (edge.isVisible) {
      availableDialog.push(edge);
    }
  });
  return availableDialog;
};



function submit(branch: Branch) {
  emit('submit', branch.dialog);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instantiateAvailableDialog(), (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index + option.dialog,
        class: "dialogue-option",
        onClick: ($event: any) => (submit(option))
      }, [
        _createElementVNode("p", null, _toDisplayString(option.dialog), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})